
import './App.css';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import Header from './Header';
import Footer from './Footer';
import HeroSlider from './HeroSlider';
import ServicesPage from './ServicesPage';
import ContactSection from './ContactSection';
import ContactSection2 from './ContactSection2';
import About from './About';
import Moving_with_a_lifting_crane from './Moving_with_a_lifting_crane';
import Building_Transportation from './Building_Transportation';
import Crane_Rental from './Crane_Rental';
import Crane_work_nationwide from './Crane_work_nationwide';
import WorksGallery from './WorksGallery';
import Relocation_of_buildings from './Category/Relocation_of_buildings';
import Lifting_Buildings from './Category/Lifting_Buildings';
import BuildingRehabilitation from './Category/BuildingRehabilitation';
import Transportation_of_protective_equipment_and_mobile_safe_room from './Category/Transportation_of_protective_equipment_and_mobile_safe_room';
import Transportation_of_building_materials from './Category2/Transportation_of_building_materials';
import Transporting_wood from './Category2/Transporting_wood';
import Transporting_heavy_equipment from './Category2/Transporting_heavy_equipment';
import Container_Transportation from './Category2/Container_Transportation';
import Transportation_and_lifting_of_glass_in_a_vacuum from './Category2/Transportation_and_lifting_of_glass_in_a_vacuum';
import Transportation_of_industrial_and_heavy_generators from './Category2/Transportation_of_industrial_and_heavy_generators';
import Basket_crane_rental from './Category3/Basket_crane_rental';
import Crane_Rental1 from './Category3/Crane_Rental1';
import Hourly_Lifting_Basket_Rental from './Category3/Hourly_Lifting_Basket_Rental';
import Renting_a_basket_crane_for_lifting_a_person from './Category3/Renting_a_basket_crane_for_lifting_a_person';
import Privacy_Policy from './Privacy_Policy/Privacy_Policy';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import CookieConsent from './CookieConsent';
import { AccessibilityWidget } from 'react-accessibility';
import WhatsAppBot from './WhatsAppBot';
import styled from "styled-components";
import { Redirect } from "react-router-dom";
import { useEffect } from "react";
import NotFound from "./NotFound";
///import Adsense from "./Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)

function App() {

const AdsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  /* הכי חשוב */
  min-height: 0 !important;
  height: auto !important;
  overflow: hidden;

  /* מבטל בלוק של Adsense */
  ins.adsbygoogle {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
    line-height: 0;
  }
`;

const seo = {
  title:
  "נצר הובלות ומנופים בע״מ | הובלות, מנופים, הרמות ושינוע",
  description:
    "נצר הובלות ומנופים בע״מ מתמחים בשירותי הובלה, הובלות עם מנוף, הרמות, שינוע ציוד, הובלת ציוד כבד והובלות פרטיות ועסקיות. שירות מקצועי, אמין ומהיר.",

  keywords:
    "נצר הובלות ומנופים, הובלות, חברת הובלות, הובלות עם מנוף, מנוף להובלה, שירותי מנוף, הרמות, שינוע, הובלת ציוד כבד, הובלות דירה, הובלות לעסקים, מנופים, הובלה עם מנוף",

  url: "https://netzertovala.co.il/",

  image: "https://netzertovala.co.il/logo192.jpeg"
};

  return (



  <React.Fragment>
        <Router>




          {/* SEO */}
<Helmet>

  <title>{seo.title}</title>

  <meta
    name="description"
    content={seo.description}
  />

  <meta
    name="keywords"
    content={seo.keywords}
  />

  <meta
    name="robots"
    content="index, follow"
  />


  {/* =====================================================
      CANONICAL
  ===================================================== */}

  <link
    rel="canonical"
    href={seo.url}
  />


  {/* =====================================================
      OPEN GRAPH
  ===================================================== */}

  <meta
    property="og:title"
    content={seo.title}
  />

  <meta
    property="og:description"
    content={seo.description}
  />

  <meta
    property="og:image"
    content={seo.image}
  />

  <meta
    property="og:url"
    content={seo.url}
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:site_name"
    content="נצר הובלות ומנופים בע״מ"
  />

  <meta
    property="og:locale"
    content="he_IL"
  />


  {/* =====================================================
      TWITTER
  ===================================================== */}

  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content={seo.title}
  />

  <meta
    name="twitter:description"
    content={seo.description}
  />

  <meta
    name="twitter:image"
    content={seo.image}
  />

</Helmet>




          <Header/>

               <CookieConsent />

          <WhatsAppBot />
            
    
          <AccessibilityWidget />
     
       

       
          <Switch>

              <Route exact path="/" component={HeroSlider} /> 
               <Route exact path="/ServicesPage" component={ ServicesPage} />       
               <Route exact path="/ContactSection2" component={ContactSection2 } />       
               <Route exact path="/About" component={About} />    
               <Route exact path="/Moving_with_a_lifting_crane" component={Moving_with_a_lifting_crane}/>   
               <Route exact path="/Building_Transportation" component={Building_Transportation} />   
               <Route exact path="/Crane_Rental" component={Crane_Rental} />   
               <Route exact path="/Crane_work_nationwide" component={Crane_work_nationwide} />  
               <Route exact path="/WorksGallery" component={WorksGallery} />  
               <Route exact path="/Relocation_of_buildings" component={Relocation_of_buildings} />
               <Route exact path="/Lifting_Buildings" component={Lifting_Buildings} />  
               <Route exact path="/BuildingRehabilitation" component={BuildingRehabilitation} />  
               <Route exact path="/Transportation_of_protective_equipment_and_mobile_safe_room" component={Transportation_of_protective_equipment_and_mobile_safe_room} />  
               <Route exact path="/Transportation_of_building_materials" component={Transportation_of_building_materials} /> 
               <Route exact path="/Transporting_wood" component={Transporting_wood} /> 
               <Route exact path="/Transportation_and_lifting_of_glass_in_a_vacuum" component={Transportation_and_lifting_of_glass_in_a_vacuum} /> 
               <Route exact path="/Transporting_heavy_equipment" component={Transporting_heavy_equipment} /> 
               <Route exact path="/Container_Transportation" component={Container_Transportation} /> 
               <Route exact path="/Transportation_of_industrial_and_heavy_generators" component={Transportation_of_industrial_and_heavy_generators} /> 
               <Route exact path="/Basket_crane_rental" component={Basket_crane_rental} /> 
               <Route exact path="/Crane_Rental1" component={Crane_Rental1} /> 
               <Route exact path="/Hourly_Lifting_Basket_Rental" component={Hourly_Lifting_Basket_Rental} /> 
               <Route exact path="/Renting_a_basket_crane_for_lifting_a_person" component={Renting_a_basket_crane_for_lifting_a_person} /> 



               <Route exact path="/Privacy_Policy" component={Privacy_Policy} /> 
<Route component={NotFound} />


              </Switch>

<Footer />


      </Router>

    </React.Fragment>

  );
}
export default App;


  
